import * as LDClient from 'launchdarkly-js-client-sdk';
import { MISSING_EMAIL } from 'shared/constants';
import Events, { fire } from 'utils/events';
export var FlagName;
(function (FlagName) {
    FlagName["FULLSTORY"] = "external-fullstory-website";
    FlagName["CHECKOUT_COMPLETION_EXPERIMENT"] = "website-improve-checkout-completion";
})(FlagName || (FlagName = {}));
const FLAG_DEFAULTS = {
    'external-fullstory-website': 'default',
    'website-improve-checkout-completion': 'default'
};
const LD_CONTEXT = {
    kind: 'multi',
    user: {
        key: Events.deviceID,
        email: Events.email
    },
    device: {
        key: Events.deviceID
    }
};
const LD_ANONYMOUS_CONTEXT = {
    kind: 'multi',
    user: {
        key: 'anonymous-user',
        email: '',
        anonymous: true
    },
    device: {
        key: Events.deviceID
    }
};
export async function updateLDContextEmail(emailAddress) {
    if (LD_CONTEXT.user.email === emailAddress) {
        return Promise.resolve(undefined);
    }
    const context = Object.assign(Object.assign({}, LD_CONTEXT), { user: Object.assign(Object.assign({}, LD_CONTEXT.user), { email: emailAddress }) });
    return await (LD_CLIENT === null || LD_CLIENT === void 0 ? void 0 : LD_CLIENT.identify(context));
}
function isUserAnonymous() {
    if (Events.email === MISSING_EMAIL) {
        return true;
    }
    return !Events.email;
}
// evaluateFlag returns a value for a given feature flag.
// It first looks for a URL param with the flag's name, offering a way to avoid random assignment.
// If no such param is available, it evaluates the flag via LaunchDarkly.
let LD_CLIENT;
if (typeof window !== 'undefined' && process.env.LAUNCH_DARKLY_KEY) {
    const ldContext = isUserAnonymous() ? LD_ANONYMOUS_CONTEXT : LD_CONTEXT;
    const options = { evaluationReasons: true };
    LD_CLIENT = LDClient.initialize(process.env.LAUNCH_DARKLY_KEY, ldContext, options);
}
export const evaluateFlag = (name, options = {}, hadInitializationError = false) => {
    const defaultValue = FLAG_DEFAULTS[name];
    const urlParams = new URLSearchParams(window.location.search);
    const urlParamValue = urlParams.get(name);
    let value = '';
    let detail;
    let userContext;
    if (urlParamValue) {
        value = JSON.parse(urlParamValue);
    }
    else {
        userContext = (LD_CLIENT === null || LD_CLIENT === void 0 ? void 0 : LD_CLIENT.getContext()).user;
        detail = LD_CLIENT === null || LD_CLIENT === void 0 ? void 0 : LD_CLIENT.variationDetail(name, defaultValue);
        value = detail === null || detail === void 0 ? void 0 : detail.value;
    }
    const { shouldLogTestGroup } = options;
    if (shouldLogTestGroup) {
        let group;
        if (typeof value === 'string') {
            group = value;
        }
        else if (typeof value === 'boolean') {
            group = value ? 'true' : 'false';
        }
        else {
            group = JSON.stringify(value);
        }
        fire('log.test_group', {
            type: name,
            group,
            ldDetail: detail,
            userContext,
            hadInitializationError
        });
    }
    return value;
};
export const evaluateFlagAsync = async (name, options = {}) => {
    try {
        await (LD_CLIENT === null || LD_CLIENT === void 0 ? void 0 : LD_CLIENT.waitForInitialization());
        return evaluateFlag(name, options);
    }
    catch (e) {
        fire('log.ld_initialize_failure', {
            type: name,
            error: e
        });
        // Still return the default evaluation
        return evaluateFlag(name, options, true);
    }
};
